import React, { Fragment } from 'react';

import "./resources/css/black_accordion.css"

import Constants from './config.js'
import { NotEnoughTokensError } from "./Contexts/UserContext/UserContext.js"
import { FormattedNumber } from "./components/FormattedNumber.js";
import { TextCopy } from './components/WithPopup/TextCopyQR.js';
import { BSVTooSmallSendAmountError, NotEnoughBSVError } from './Errors/errors_bsv.js';
import Indent from './components/Indent.js';
import { ContextError } from './Contexts/GlobalErrorContext.js';
import { getLog } from './helpers/helpers.js';
import { AccordionWithCloseBelow } from './components/AccordionWithCloseBelow.js';


// TODO translate all myerror="" strings in this file to english

// Browser-level fetch failures (no network / disconnected / DNS / blocked).
// Matches Chromium/Edge/Safari ("Failed to fetch"),
// Firefox ("NetworkError when attempting to fetch resource"),
// and other environments ("Network request failed").
export function isNetworkErrorString(str) {
	if (typeof str !== 'string') {
		try { str = str.toString() } catch (e) { return false }
	}
	if (str.includes("Failed to fetch")) return true
	if (str.includes("NetworkError when attempting to fetch resource")) return true
	if (str.includes("Network request failed")) return true
	return false
}

// true when the browser reports it is offline (best-effort, not all browsers).
export function isBrowserOffline() {
	if (typeof navigator === 'undefined') return false
	return navigator.onLine === false
}

export function translateErrorToJSXMessage(error, prefix_message = "Erreur:") { // default prefix
	/*
	 *    just call with an error or a message,
	 *    or you can give both an error and a message to display before it to give even more context
	 */
	const function_id = "translateErrorToMessage_JSX(): "
	const log = getLog(function_id)

	if (!error) return error

	console.error(function_id, error)

	if (prefix_message.length > 0 && !prefix_message.includes(':')) prefix_message = prefix_message + ": "
	else prefix_message += ' '

	// 
	// TODO gérer toutes les erreurs comme ça
	//

	var error_clean = error.toString()

	/*
	// let's not display to the users the links to RUN or WoC api because it is confusing
	// WRONG it is nice to not display this to end users but we should keep them in log files
	if (error_clean.includes("http://") || error_clean.includes("https://") || error_clean.includes("api.run.network")) {
		var indexof = error_clean.indexOf("http://")
		if (indexof === -1) indexof = error_clean.indexOf("https://")
		if (indexof === -1) indexof = error_clean.indexOf("api.run.network")
		if (indexof !== -1) {
			// let's hide the full link because
			// if the full link is needed for debugging you'll find it in the logs anyways
			var error_clean_before = error_clean.substring(0, indexof - 1); // verified
			var error_clean_after = error_clean.substring(indexof, error_clean.length); // verified
			error_clean_after = error_clean_after.split(/\s+/) // split on newlines OR spaces

			let error_clean_url = error_clean_after[0]
			error_clean_after = error_clean_after.slice(1).join(' ') // remove first
			// console.error(">>> error_clean_after = ",error_clean_after)
			// error_clean_domain: http://truc.machine.wow/whatthe/cheese => truc.machine (but will also remove any occurenc ef 'api.')
			let error_clean_domain = error_clean_url.split('://').slice(-1)[0].split('/')[0].split('.').slice(0, -1).join('.').split('api.').join('')
			error_clean_domain = String(error_clean_domain).replace("whatsonchain", "WOC")
			error_clean = error_clean_before + " [" + error_clean_domain + " network call] " + error_clean_after
		}
	}
	*/

	/*
	// let's not display RUN's "hints"
	// WRONG it is nice to not display this to end users but we should keep them in log files
	if(error_clean.includes("Hint:")){
		error_clean = error_clean.split("Hint:")[0]
	}
	*/

	var isUntranslatedError = false
	var myerror = "UntranslatedError: " + error_clean // default value // beware myerror can be JSX

	if (error instanceof NotEnoughBSVError) {
		var nbsatoshistosend = error.nbsatoshistosend
		var balancebsv = error.balancebsv
		//
		myerror =
			<Fragment>
				Echec: Vous ne possédez pas assez de BSV pour faire cet envoi.<br />
				Vous essayez d'envoyer &nbsp;
				<FormattedNumber value={nbsatoshistosend} decimals="0" separator=" " />
				&nbsp; satoshis et vous n'avez que &nbsp;
				<FormattedNumber value={balancebsv} decimals="0" separator=" " />
				&nbsp; satoshis.
			</Fragment>
	}
	else if (error instanceof BSVTooSmallSendAmountError) {
		var nbsatoshistosend = error.nbsatoshistosend
		var bsvfee = error.bsvfee
		var sendsatoshis_afterfees = error.sendsatoshis_afterfees
		//
		myerror =
			<Fragment>
				Echec: Impossible d'envoyer un montant aussi faible.<br />
				<br /><Indent />nombre de satoshis à envoyer :&nbsp;
				<FormattedNumber value={nbsatoshistosend} decimals="0" separator=" " />
				<br /><Indent />frais du réseau : {bsvfee} satoshis
				<br /><Indent />nombre de satoshis reçus après frais :&nbsp;
				<FormattedNumber value={sendsatoshis_afterfees} decimals="0" separator=" " />
			</Fragment>
	}
	else { }

	var founderror = false
	if (error instanceof ContextError) {
		// context errors are nested one into the other until there is another type at the end so let's try to extract it
		var suberror = error
		while (suberror instanceof ContextError) {
			suberror = suberror.error
		}
		if (suberror instanceof NotEnoughTokensError) {
			founderror = true
			myerror = "Vous ne disposez pas d'assez de Delphes pour faire cet envoi. Vous essayez d'envoyer "
				+ suberror.token_nbsend + " Delphes et vous en possédez " + suberror.token_totalowned
		}
	}

	log("founderror = ", founderror, " for ", error_clean)

	if (founderror === false) // if we still haven't found an error
	{
		myerror = translateErrorAsString(error_clean)
		if (myerror === error_clean) {
			isUntranslatedError = true
			myerror = "UntranslatedError: " + error_clean // default value // beware myerror can be JSX
		}
	}

	log("isUntranslatedError = ", isUntranslatedError, " for ", error_clean, "\n=> myerror=", myerror)

	let introMessage = Constants.ERROR_INTROMESSAGE

	if(error_clean.includes('TokkenrBlockchain')) {
		introMessage = <>
			{introMessage}
			Problem with the TokkenR Indexing node.
		</>
	}

	if (isNetworkErrorString(error_clean)) {
		introMessage = Constants.ERROR_NETWORK_INTROMESSAGE
	}

	// if (isUntranslatedError) {
	return (
		<div style={{
			// border: "2px solid #670000",
			border: "1px solid #00e8d1",
			borderRadius: "0.9em",
			padding: "30px",
			overflowWrap: "break-word",
			wordBreak: "break-word",
			marginTop: "7em",
			transitionDuration: "2s",
			background: "black",
		}}> {/* styling to ensure long txid don't go out of screen */}
			<div style={{
				fontSize: "16px",
				fontWeight: "normal",
				color: "white",
				fontFamily: "inherit",
				background: "none"
			}}>
				{Constants.ERROR_INTROMESSAGE}
			</div>

			<AccordionWithCloseBelow title="Additional information">
				<TextCopy value={prefix_message + myerror} noUserSelectAll style={{ fontSize: "small" }} />
			</AccordionWithCloseBelow>
		</div>
	)
	/*
	}
	else { // not if (isUntranslatedError)
		return (
			<div style={{
				fontSize: "16px",
				fontWeight: "normal",
				color: "white",
				fontFamily: "inherit",
				background: "none"
			}}>
				<div style={{
					background: "#d1d1d1",
					borderRadius: "1em",
					padding: "1em",
					color: "black"
				}}>
					{myerror}
				</div>
					{Constants.ERROR_INTROMESSAGE_SHORT}
			</div>
		)
	}
	*/
}


export function translateErrorAsString(error_clean) {

	// type safety check
	if (typeof error_clean !== 'string') {
		error_clean = error_clean.toString()
	}

	var myerror = error_clean // default, not translation

	if (error_clean.includes("Not enough funds")) {
		myerror = "Pas assez de BSV dans le wallet, commencez par envoyer des BSV sur le wallet."
	}
	else if (error_clean.includes("TimeoutError")) {
		myerror = "La requête à échouée (timeout), essayez de recharger le portefeuille et recommencez."
	}
	else if (isNetworkErrorString(error_clean)) {
		var offline_hint = isBrowserOffline()
			? " (the browser also reports that the device is currently offline)"
			: ""
		myerror = "Your Internet connection appears to be disconnected."
			+ " Please verify that you are connected to the Internet, then reload your wallet and try again."
			+ offline_hint
			+ "\n\nError details: " + error_clean
	}
	else if (error_clean.includes("Invalid owner") || error_clean.includes("Invalid character in address")
		|| error_clean.includes("Invalid Address")) {
		myerror = "L'adresse fournie n'est pas valide, veuillez la vérifier."
	}
	else if (error_clean.includes("SmartContractError:")) {
		// extract the errorCode
		//console.error(function_id+" SmartContractError : ", error_clean)
		var errorCode = parseInt(error_clean.split("SmartContractError:")[1].split(':')[0])
		var errorMessage = error_clean
		//
		myerror = "Erreur dans le SmartContract. Code d'erreur: " + errorCode + ":\n\n" + errorMessage// TODO ADD TRANSLATIONS

		if (errorCode === 413) {
			myerror = "Erreur de SmartContract: Cette adresse est déjà blacklistée."
		}
	}
	else if (error_clean.includes("too-long-mempool-chain")) {
		myerror = "Vous avez atteint la limite blockchain de transactions en "
			+ "chaine dans le même bloc, veuillez attendre le prochain bloc puis recommencer."
			+ " (PS cette limite sera bientôt supprimée)."
	}
	else if (error_clean.includes("Broadcast failed")) {
		myerror = "Le wallet ne semble pas correctement synchronisé avec la blockchain."
			+ " Rechargez ou attendez quelques minutes avant de réésayer.\n\n" + error_clean
	}
	/*
	else if(error_clean.includes("NotEnoughTokensError")){
		var data	   = error_clean.split("NotEnoughTokensError:")[1].split(':')[0]
		var nb_to_send = parseFloat(data.split('/')[0]).toFixedDown(2)
		var nb_owned   = parseFloat(data.split('/')[1]).toFixedDown(2)
		myerror = "Vous ne disposez pas d'assez de Delphes pour faire cet envoi. Vous essayez d'envoyer "+nb_to_send+" Delphes et vous en possédez "+nb_owned
	}
	*/
	else if (error_clean.includes("mandatory-script-verify-flag-failed")) {
		myerror = "Cette opération est interdite par le SmartContract."
			+ " Êtes-vous sûr d'être le propriétaire ?"
	}
	else if (error_clean.includes("bsv.ErrorInvalidArgument")
		&& error_clean.includes("Amount is expected to be a positive integer")) {
		myerror = "Vous n'avez pas assez de BSV dans le wallet pour faire cette transaction."
			+ " Veuillez commencer par envoyer plus de BSV sur le wallet puis recommencer.\n\n"
			+ "Détails de l'erreur: " + error_clean
	}
	else if (error_clean.includes('BlockchainNodeError')) {
		myerror = "Problème de noeud blockchain temporairement indisponible. "
			+ "Détails de l'erreur: " + error_clean
	}
	else if (error_clean.includes('TokkenrBlockchain')) {
		myerror = "Problème de noeud d'indexation TokkenR temporairement indisponible. "
			+ "Détails de l'erreur: " + error_clean
	}

	return myerror
}